import { useState, useEffect } from "react";
import { MIDTRANS_API_URL, MIDTRANS_CLIENT_ID } from "../Utils/const";

declare global {
    interface Window {
        snap: any;
    }
}

const useSnap = () => {
    const [snap, setSnap] = useState<any>(null);

    useEffect(() => {
        const myMidtransClientKey: string = MIDTRANS_CLIENT_ID ?? '';
        const script = document.createElement('script');
        script.src = `${MIDTRANS_API_URL}/snap/snap.js`;
        script.setAttribute('data-client-key', myMidtransClientKey);
        script.onload = () => {
            setSnap(window.snap);
        };
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    const snapEmbed = (snap_token: any , embedId: any , action: any ) => {
        if(snap){
            snap.embed(snap_token, {
                embedId,
                onSuccess: function (result: any)  {
                    console.log('success', result);
                    action.onSuccess(result);
                },
                onPending: function(result: any){
                    console.log('pending', result);
                    action.onPending(result);
                },
                onClose: function () {
                    action.onClose();
                }
            })
        }
    }

    return {snapEmbed}
}

export default useSnap;